import { omit } from "lodash-es";

import { IHttpRequestConfig } from "@/browser";
import { AttachmentLike, getAttachmentMeta } from "@/data/attachments";
import { prepareDownloader } from "@/eworkitComponents";

interface IAttachmentProps {
  attachment: AttachmentLike;
}

export const urlPropsGetter = async (props: IAttachmentProps, options?: IHttpRequestConfig) => {
  const { systemId } = props.attachment;

  try {
    const meta = await getAttachmentMeta({ systemId }, options);

    if (meta.publicUrl) {
      return meta.publicUrl;
    }
  } catch {
    // hide error
  }

  return "";
};

const urlPropsOmmiter = (props: IAttachmentProps) => {
  return omit(props, ["attachment"]);
};

export const downloaderBuilder = prepareDownloader<IAttachmentProps>(urlPropsGetter, urlPropsOmmiter);
